module.exports = __webpack_public_path__ + "certificaat_les_3_lllmbo.pdf";